import { CountryInfo } from "./country-info";
import { RegionInfo } from "./region.info";

export class CountryCommonInfo {
  allCountries: CountryInfo[];
  usStates: RegionInfo[];
  caRegions: RegionInfo[];
}
